export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Project-Portfolio-3-960.7ec48904.webp";